import { v4 as uuidv4 } from "uuid";
import { Buffer } from "buffer/";

const webStorageKeyPrefix = "natklok";

export const generateOrGetClientId = () => {
  let id = tryToParseStorageKeyValue("client-id", "string");
  if (id !== null) {
    return id;
  } else {
    id = uuidv4();
    setStorageElement("client-id", id);
    return id;
  }
};

export const tryToParseStorageKeyValue = (keyName, typeOf = "object", storageType = "local") => {
  // Check if item exists
  let item = null;
  let keyNameWithPrefix = `${webStorageKeyPrefix}.${keyName}`;
  // eslint-disable-next-line default-case
  switch (storageType) {
    case "local":
      item = localStorage.getItem(keyNameWithPrefix);
      break;
    case "session":
      item = sessionStorage.getItem(keyNameWithPrefix);
      break;
  }
  if (!item) {
    return null;
  }
  // Try to parse value
  try {
    let buff = "";
    if (process.env.NODE_ENV === "production") {
      buff = Buffer.from(item, "base64").toString("utf8");
    } else {
      buff = item;
    }
    let res = JSON.parse(buff);
    if (typeof res === typeOf) {
      return res;
    } else {
      throw TypeError;
    }
  } catch (e) {
    // eslint-disable-next-line default-case
    switch (storageType) {
      case "local":
        localStorage.removeItem(keyNameWithPrefix);
        break;
      case "session":
        sessionStorage.removeItem(keyNameWithPrefix);
        break;
    }
    return null;
  }
};

export const setStorageElement = (key, value, storageType = "local") => {
  let keyWithPrefix = `${webStorageKeyPrefix}.${key}`;
  let stringVal = JSON.stringify(value);
  let bufferVal = "";
  if (process.env.NODE_ENV === "production") {
    bufferVal = Buffer.from(stringVal, "utf8").toString("base64");
  } else {
    bufferVal = stringVal;
  }
  // eslint-disable-next-line default-case
  switch (storageType) {
    case "local":
      localStorage.setItem(keyWithPrefix, bufferVal);
      break;
    case "session":
      sessionStorage.setItem(keyWithPrefix, bufferVal);
      break;
  }
  return true;
};

export const hasChosenSettings = () => {
  if (tryToParseStorageKeyValue("profiles") && tryToParseStorageKeyValue("age", "string")) {
    return true;
  }
  return false;
};

export const hasPlayedBefore = () => {
  if (hasChosenSettings()) {
    return true;
  }
  return false;
};

export const clearStoredAnswersAndSettings = () => {
  localStorage.removeItem(`${webStorageKeyPrefix}.correctQuestions`);
  localStorage.removeItem(`${webStorageKeyPrefix}.incorrectQuestions`);
  localStorage.removeItem(`${webStorageKeyPrefix}.age`);
  localStorage.removeItem(`${webStorageKeyPrefix}.profiles`);
  localStorage.removeItem(`${webStorageKeyPrefix}.quizModules`);
  localStorage.removeItem(`${webStorageKeyPrefix}.quizModules3`);
  localStorage.removeItem(`${webStorageKeyPrefix}.correct-variants`);
  localStorage.removeItem(`${webStorageKeyPrefix}.correct-variants3`);
  sessionStorage.removeItem(`${webStorageKeyPrefix}.prevBadgeScores`);
  return true;
};

export const clearStorage = () => {
  localStorage.clear();
  sessionStorage.clear();
  return true;
};
